export default __webpack_public_path__ + "static/logo-dc8346b4c56f07f62df6b4284f121076.gif";